var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuantityCounter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 34,
    viewBox: "0 0 100 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_197_6251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.504 18.114V19.518H19.202V18.114H14.504Z",
    fill: "#98A1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4C0.5 2.067 2.067 0.5 4 0.5H33.5V33.5H4C2.067 33.5 0.5 31.933 0.5 30V4Z",
    stroke: "#98A1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.486 12.768H49.43V24H50.942V11.4H47.486V12.768Z",
    fill: "#98A1FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.5,
    y: 0.5,
    width: 33,
    height: 33,
    stroke: "#98A1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.31 18.168H82.064V20.94H83.216V18.168H85.97V17.124H83.216V14.352H82.064V17.124H79.31V18.168Z",
    fill: "#98A1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5 0.5H96C97.933 0.5 99.5 2.067 99.5 4V30C99.5 31.933 97.933 33.5 96 33.5H66.5V0.5Z",
    stroke: "#98A1FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_197_6251"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 34,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuantityCounter);
export default __webpack_public_path__ + "static/media/quantity_counter.db5a1bf497375f7f5f5cf6ce9ed1a9df.svg";
export { ForwardRef as ReactComponent };